import type { GraphSharedViewParameters } from '@ipfabric/utils';
import { loadEmptyGraph } from 'components/Graph/commands/loadEmptyGraph';
import { loadView } from 'components/Graph/commands/loadView';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import { areSharedViewSnapshotsLoaded } from '../helpers/areSharedViewSnapshotsLoaded';
import type { GraphCommandFactory } from '../model/GraphCommandContext';

interface LoadSharedViewCommand {
  parameters: GraphSharedViewParameters;
  loadedSnapshots: Snapshot[];
}

export const loadSharedView: GraphCommandFactory<LoadSharedViewCommand> =
  (cmdContext, dispatch) => async (command) => {
    const snapshotsLoaded = areSharedViewSnapshotsLoaded(
      command.parameters,
      command.loadedSnapshots,
    );

    if (snapshotsLoaded) {
      await dispatch(loadView, {
        view: command.parameters.viewUrlData!.graphView,
        viewUrlId: command.parameters.viewUrlId,
      });
    } else {
      cmdContext.updateState((draft) => {
        draft.sharedViewId = command.parameters.viewUrlId;
      });
      dispatch(loadEmptyGraph);
    }
  };
